<template>
    <div>
        <p v-for="(t, i) in value" :key="i" >
            状态: {{ getStatusName(t.valid) }} <br />
            message: {{t.message}}
        </p>
    </div>
</template>

<script>

export default {
    name: 'MessageWeChat.vue',
    props: {
        value: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {

        }
    },
    created(){

    },
    mounted(){
    },
    methods: {
        getStatusName(value) {
            return value === 1 ? '审核成功' : value === 0 ? '审核失败' : ''
        }
    }
}
</script>

<style scoped>

</style>
